import { computed, getCurrentInstance } from 'vue';
import { types } from '../../store/types/types';
import { MultiselectGroup, type MultiselectOption } from '../../../shared/types';
import { permissionEnum } from '../../../shared/enums/permissionEnum';

export const useGroupFilter = () => {
  const { proxy } = getCurrentInstance();
  const userGroups = computed(() => proxy.$store.getters[types.GET_USER_GROUPS] || []);
  const distributionListGroups = computed(() => proxy.$store.getters[types.GET_DISTRIBUTION_LIST_GROUPS] || []);
  const hasDistributionListPermission = computed(() =>
    proxy.$store.getters[types.HAS_PERMISSION](permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS)
  );
  const activeInstitutionCodes = computed(() => {
    const activeInstitution = proxy.$store.getters[types.GET_SELECTED_INSTITUTION];
    return proxy.$store.getters[types.GET_ACTIVE_INSTITUTIONS] || [activeInstitution?.institutionCode] || [];
  });

  const groupOptions = computed(() => {
    let sourceGroups: typeof userGroups.value;

    if (hasDistributionListPermission.value) {
      const merged = [...userGroups.value, ...distributionListGroups.value];

      // Deduplicate by id + institutionCode combination
      const deduplicatedMap = new Map<string, typeof userGroups.value[number]>();
      merged.forEach(group => {
        const key = `${group.id}-${group.institutionCode}`;
        if (!deduplicatedMap.has(key)) {
          deduplicatedMap.set(key, group);
        }
      });

      sourceGroups = Array.from(deduplicatedMap.values());
    } else {
      sourceGroups = userGroups.value;
    }

    const options: MultiselectOption[] = sourceGroups
      .filter(group => activeInstitutionCodes.value.includes(group.institutionCode))
      .sort((a, b) => a.name.localeCompare(b.name, 'da', { sensitivity: 'base' }))
      .map(group => ({
        label: group.name.toString(),
        id: parseInt(group.id),
        trackBy: group.name.toString(),
      }));

    return [
      {
        label: proxy.$t('label.groups').toString(),
        options,
      },
    ] as MultiselectGroup<MultiselectOption>[];
  });

  return { groupOptions };
};
